module.exports = __webpack_public_path__ + "img/farming_40.c89d6437.png";